// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State = require("../Control.Monad.State/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_Monad_State_Trans = require("../Control.Monad.State.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Random_PseudoRandom = require("../Random.PseudoRandom/index.js");
var Ritoppu_Model_Repository = require("../Ritoppu.Model.Repository/index.js");
var runGenerator = function (seed) {
    return function (f) {
        return Control_Monad_State.evalState(f)(seed);
    };
};
var newInt = function (from) {
    return function (to) {
        return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.get(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity)))(function (v) {
            var v1 = Random_PseudoRandom.randomR(Random_PseudoRandom.randomInt)(from)(to)(v);
            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.put(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(v1.newSeed))(function () {
                return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(v1.newVal);
            });
        });
    };
};
var newItem = function (gen) {
    return Data_Functor.map(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity))(gen)(newInt(0)(100));
};
var newPoint = function (fromX) {
    return function (fromY) {
        return function (toX) {
            return function (toY) {
                return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(newInt(fromX)(toX))(function (v) {
                    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(newInt(fromY)(toY))(function (v1) {
                        return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                            x: v,
                            y: v1
                        });
                    });
                });
            };
        };
    };
};
var newRect = function (v) {
    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(newPoint(6)(6)(10)(10))(function (v1) {
        return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(newPoint(1)(1)((v.x - v1.x | 0) - 1 | 0)((v.y - v1.y | 0) - 1 | 0))(function (v2) {
            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                a: {
                    x: v2.x,
                    y: v2.y
                },
                b: {
                    x: v2.x + v1.x | 0,
                    y: v2.y + v1.y | 0
                }
            });
        });
    });
};
var newPointInRect = function (v) {
    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(newInt(v.a.x)(v.b.x))(function (v1) {
        return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(newInt(v.a.y)(v.b.y))(function (v2) {
            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))({
                x: v1,
                y: v2
            });
        });
    });
};
var samples = function (n) {
    return function (xs) {
        if (Data_Array["null"](xs)) {
            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))([  ]);
        };
        if (n > 0) {
            return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(newInt(0)(Data_Array.length(xs)))(function (v) {
                var v1 = Data_Array.index(xs)(v);
                if (v1 instanceof Data_Maybe.Just) {
                    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(samples(n - 1 | 0)(xs))(function (v3) {
                        return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Array.cons(v1.value0)(v3));
                    });
                };
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))([  ]);
                };
                throw new Error("Failed pattern match at Ritoppu.Random (line 53, column 7 - line 58, column 18): " + [ v1.constructor.name ]);
            });
        };
        if (Data_Boolean.otherwise) {
            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))([  ]);
        };
        throw new Error("Failed pattern match at Ritoppu.Random (line 48, column 1 - line 48, column 66): " + [ n.constructor.name, xs.constructor.name ]);
    };
};
var newFromRepository = function (repository) {
    return Data_Functor.map(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity))(Ritoppu_Model_Repository.pickInRepository(repository))(newInt(0)(repository.total));
};
var newCreature = function (gen) {
    return Data_Functor.map(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity))(gen)(newInt(0)(100));
};
module.exports = {
    runGenerator: runGenerator,
    newPoint: newPoint,
    newPointInRect: newPointInRect,
    newCreature: newCreature,
    newItem: newItem,
    newInt: newInt,
    newRect: newRect,
    newFromRepository: newFromRepository
};
